import { createContext, useContext } from "react";

/**
 * The header's page-actions slot. The context lives apart from the components so Fast Refresh can
 * hot-reload them (`react-refresh/only-export-components`, as `ui/button-variants.ts` does).
 */
export interface HeaderActionsContextValue {
  slot: HTMLElement | null;
  setSlot: (element: HTMLElement | null) => void;
}

export const HeaderActionsContext = createContext<HeaderActionsContextValue>({
  slot: null,
  setSlot: () => {},
});

export function useHeaderActionsContext(): HeaderActionsContextValue {
  return useContext(HeaderActionsContext);
}
